import { Component } from '@angular/core';
import { ValidationService } from 'src/app/state';

@Component({
  selector: 'em-validation-summary-modal',
  styleUrls: ['./validation-summary-modal.component.less'],
  templateUrl: './validation-summary-modal.component.html',
  standalone: false,
})
export class ValidationSummaryModalComponent {
  public validations$ = this.validationsService.validations$;

  public constructor(private readonly validationsService: ValidationService) {}
}
